export default "__VITE_ASSET__D2$WW6yK__"